// extracted by mini-css-extract-plugin
export default {"button":"icon_button__yatFF","a":"icon_a__8hlJd"};